var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilmTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2241_13673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 14.2976H20V16.7466H17.7778V14.5425C17 14.5425 16.2222 14.2976 15.5556 14.0527V21.6445H6.66667V4.50167H11.2222C11.4444 3.64453 11.8889 2.78738 12.3333 2.05269H1.11111C0.555556 2.05269 0 2.54248 0 3.27718V22.869C0 23.4813 0.444444 24.0935 1.11111 24.0935H21.1111C21.6667 24.0935 22.2222 23.6037 22.2222 22.869V12.9506C21.4444 13.5629 20.5556 14.0527 19.6667 14.2976ZM4.44444 21.6445H2.22222V19.1955H4.44444V21.6445ZM4.44444 16.7466H2.22222V14.2976H4.44444V16.7466ZM4.44444 11.8486H2.22222V9.39963H4.44444V11.8486ZM4.44444 6.95065H2.22222V4.50167H4.44444V6.95065ZM20 21.6445H17.7778V19.1955H20V21.6445Z",
    fill: "#525256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.318C14.6667 13.318 12 10.3792 12 6.70575C12 3.03228 14.6667 0.0935059 18 0.0935059C21.3333 0.0935059 24 3.03228 24 6.70575C24 10.3792 21.3333 13.318 18 13.318ZM18 11.9711C20.6667 11.9711 22.7778 9.64453 22.7778 6.70575C22.7778 3.76698 20.6667 1.44044 18 1.44044C15.3333 1.44044 13.2222 3.76698 13.2222 6.70575C13.2222 9.64453 15.3333 11.9711 18 11.9711ZM17.3333 9.39963L14.7778 6.5833L15.6667 5.60371L17.3333 7.44044L20.7778 3.76698L21.6667 4.74657L17.3333 9.39963Z",
    fill: "#787E82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2241_13673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0935059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmTicket);
export default __webpack_public_path__ + "static/media/film-ticket.f7a8a8504ba4abcf19f07274b3bfb3ac.svg";
export { ForwardRef as ReactComponent };